import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectPOData = state => selectState(state).data;
export const selectPOLoading = state => selectState(state).loading;
export const selectPOError = state => selectState(state).error;
export const selectPOFilterVisible = state => selectState(state).filterVisible;
export const selectPOFilters = state => selectState(state).filters;
export const selectFilterVisible = state => selectState(state).filterVisible;
export const selectTileView = state => selectState(state).tileView;
export const selectFilteredPOs = createSelector(
  [selectPOData, selectPOFilters],
  (data, { searchText }) => {
    return data.filter(entry =>
      Object.keys(entry).some(key =>
        String(entry[key]).toLowerCase().includes(searchText.toLowerCase()),
      ),
    );
  },
);
